<template>
  <div id="v-layout">
    <templateHeader></templateHeader>
    <templateMenu></templateMenu>
    <div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
      <router-view :meta="meta" :style="{minHeight: minHeight + 'px'}"></router-view>
      <templateFooter></templateFooter>
    </div>
  </div>
</template>

<script>
import templateHeader from '@/views/template/Header'
import templateMenu from '@/views/template/Menu'
import templateFooter from '@/views/template/Footer'

export default {
  data () {
    return {
      meta: {
        title: '臺北市私立靜心高級中學',
        titleTemplate: '影音隨選系統',
        keyword: '影音平台,學習系統,隨選系統,vod,live',
        description: '靜心的每一天,累積孩子與世界接軌的能量',
        ogTitle: '臺北市私立靜心高級中學',
        ogDescription: '靜心的每一天,累積孩子與世界接軌的能量',
        ogType: 'website',
        //                    ogImage: this.baseURL+"/upload/convert_video_thumbnail/default.jpg",
        ogUrl: location.href,
        ogSite_name: '臺北市私立靜心高級中學'
      },
      minHeight: this.resizeMinHeight()
    }
  },
  components: {
    templateHeader,
    templateMenu,
    templateFooter
  },
  watch: {
    '$route' (to, from) {
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    let self = this
    window.onresize = function () {
      self.minHeight = self.resizeMinHeight()
    }

    //    this.checkOtherDeviceLoggedIn()
  },
  methods: {
    checkOtherDeviceLoggedIn () {
      // 確認是否有其他裝置登入
      let self = this
      let checkTime = 10 * 1000 // 每 N 秒鐘確認一次裝置登入
      // 設置 N 秒執行一次
      let checkToLogout = setInterval(function () {
        self.$http.post('/checkOtherDeviceLoggedIn', {
          data: {
            api_token: self.$store.state.token
          }
        }).then(function (response) {
          if (response.data.result !== false) {
            self.$store.dispatch('logout', self.$store.state.token)
              .then(() => {
                self.$modal.show('dialog', {
                  title: '確認視窗',
                  text: '您的帳號在其他裝置登入，系統將登出本裝置。',
                  buttons: [
                    {
                      title: '關閉視窗',
                      handler: () => {
                        clearInterval(checkToLogout)
                        self.$router.push({ name: 'Login' })
                        self.$modal.hide('dialog')
                      }
                    }
                  ]
                })
              })
          }
        }).catch(err => {
          console.log(err)
        })
      }, checkTime)
    },
    resizeMinHeight () {
      return document.documentElement.clientHeight - 207
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      titleTemplate: '%s - ' + this.meta.titleTemplate,
      meta: [
        { vmid: 'keywords', name: 'keywords', content: this.meta.keyword },
        { vmid: 'description', name: 'description', content: this.meta.description },
        { vmid: 'image', name: 'image', content: this.meta.ogImage },
        { vmid: 'og:title', property: 'og:title', content: this.meta.ogTitle, template: '%s - ' + this.meta.titleTemplate },
        { vmid: 'og:description', property: 'og:description', content: this.meta.ogDescription },
        { vmid: 'og:type', property: 'og:type', content: this.meta.ogType },
        { vmid: 'og:image', property: 'og:image', content: this.meta.ogImage },
        { vmid: 'og:url', property: 'og:url', content: this.meta.ogUrl },
        { vmid: 'og:site_name', property: 'og:site_name', content: this.meta.ogSite_name }
      ]
    }
  }
}
</script>

<style>
  .pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {
    background-color: #103151 !important;
    border-color: #103151 !important;
  }
  .pagination>li>a, .pagination>li>span {
    color: #297e9a;
  }
  h2 {
    margin-top: 0;
  }
  .v-static p {
    font-size: 16px;
  }
</style>
